import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './NotificationPopup.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import { IsStringEmpty, cleanHTML } from '../../../utilities/CommonMethods';
import { Link } from 'react-router-dom';
import RouteEndPoints from '../../../utilities/RouteEndPoints';

const NotificationPopup = (props) => {
    return (
        <FlexModal visible={props.show} width="40%">
            <div className={classes.NotificationPopup}>
                <img
                    className={classes.CloseIcon}
                    src={closeIconBlack}
                    alt="Close Icon"
                    onClick={() => props.closeClicked(props.data, 'Closed Popup')}
                />
                {
                    !IsStringEmpty(props.data.tag)
                        ? <h3 className={classes.Tag}>{props.data.tag}</h3>
                        : null
                }

                <h4 className={classes.Title}>{props.data.label}</h4>

                {
                    !IsStringEmpty(props.data.message)
                        ? <p dangerouslySetInnerHTML={{ __html: cleanHTML(props.data.message) }}></p>
                        : null
                }

                <div className={classes.ButtonContainer}>
                    {!IsStringEmpty(props.data.url)
                        ? props.data.url.indexOf('https://') > -1 || props.data.url.indexOf('http://') > -1 || props.data.url.indexOf('www.') > -1
                            ? <a href={props.data.url} target="_blank" className={classes.RemoveTextDecoration} onClick={() => props.closeClicked(props.data, 'Button Clicked')}>
                                <Button
                                    styleclass={"NonMobileOnly"}
                                    label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                    clicked={null}
                                    margin="0px"
                                    padding="8px 48px"
                                />
                                <Button
                                    styleclass={"MobileOnly"}
                                    label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                    clicked={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </a>
                            : <Link to={RouteEndPoints.HOME_PAGE + props.data.url} className={classes.RemoveTextDecoration} onClick={() => props.closeClicked(props.data, 'Button Clicked')}>
                                <Button
                                    styleclass={"NonMobileOnly"}
                                    label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                    clicked={null}
                                    margin="0px"
                                    padding="8px 48px"
                                />
                                <Button
                                    styleclass={"MobileOnly"}
                                    label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                    clicked={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </Link>
                        : <React.Fragment>
                            <Button
                                styleclass={"NonMobileOnly"}
                                label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                clicked={() => props.closeClicked(props.data, 'Button Clicked')}
                                margin="0px"
                                padding="8px 48px"
                            />
                            <Button
                                styleclass={"MobileOnly"}
                                label={!IsStringEmpty(props.data.cta) ? props.data.cta : 'OKAY'}
                                clicked={() => props.closeClicked(props.data, 'Button Clicked')}
                                margin="0px"
                                padding="1em 2em"
                                fontSize="0.625em"
                            />
                        </React.Fragment>
                    }
                </div>
            </div>
        </FlexModal>
    );
}

export default NotificationPopup;